import { useState } from 'react';
import { Loader2, ImageOff } from 'lucide-react';
import { ImageContentProps } from './types';
import { cn } from '@/lib/utils';

export function ImageContent({
  url,
  title,
  rotation,
  onLoad,
  onError,
}: ImageContentProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoading(false);
    onLoad();
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
    onError('Impossible de charger l\'image');
  };

  if (hasError) {
    return (
      <div className="flex flex-col items-center justify-center py-12 gap-3">
        <ImageOff className="w-12 h-12 text-muted-foreground" />
        <p className="text-sm text-muted-foreground">Erreur de chargement de l'image</p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-4 min-h-[200px]">
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center z-10">
          <Loader2 className="w-8 h-8 animate-spin text-primary" />
        </div>
      )}
      <img
        src={url}
        alt={title}
        onLoad={handleLoad}
        onError={handleError}
        className={cn(
          "max-w-full h-auto object-contain rounded-lg shadow-lg transition-opacity duration-300",
          isLoading && "opacity-0"
        )}
        style={{
          transform: `rotate(${rotation}deg)`,
          transformOrigin: 'center center',
        }}
        draggable={false}
      />
    </div>
  );
}
